function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } Object.defineProperty(subClass, "prototype", { value: Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }), writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (typeof call === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/* This Source Code Form is subject to the terms of the Mozilla Public
 * License, v. 2.0. If a copy of the MPL was not distributed with this
 * file, You can obtain one at http://mozilla.org/MPL/2.0/. */

/**
 * Display a password strength balloon. Component automatically
 * updates whenever changes are made to the underlying model.
 *
 * @export
 * @class PasswordStrengthBalloonView
 * @extends {BaseView}
 */
import Cocktail from 'cocktail';
import AuthErrors from '../../lib/auth-errors';
import XSS from '../../lib/xss';
import Template from '../../templates/partial/password-strength-balloon.mustache';
import BaseView from '../base';
import ExternalLinksMixin from '../mixins/external-links-mixin';
import OneVisibleOfTypeMixin from '../mixins/one-visible-of-type-mixin';
const DELAY_BEFORE_HIDE_BALLOON_EL_MS = 200;
const PASSWORD_STRENGTH_BALLOON_SELECTOR = '#password-strength-balloon';
const ESCAPED_SUMO_ARTICLE_HREF = XSS.href('https://support.mozilla.org/kb/password-strength');

let PasswordStrengthBalloonView = /*#__PURE__*/function (_BaseView) {
  _inherits(PasswordStrengthBalloonView, _BaseView);

  var _super = _createSuper(PasswordStrengthBalloonView);

  function PasswordStrengthBalloonView() {
    var _this;

    _classCallCheck(this, PasswordStrengthBalloonView);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "template", Template);

    return _this;
  }

  _createClass(PasswordStrengthBalloonView, [{
    key: "initialize",
    value: function initialize() {
      let config = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      this.listenTo(this.model, 'change:password', this.update);
      this.listenTo(this.model, 'change:inputFocused', this.hideOrShow);
    }
  }, {
    key: "setInitialContext",
    value: function setInitialContext(context) {
      const validationError = this.model.validationError;
      context.set({
        escapedCommonPasswordLinkAttrs: `href="${ESCAPED_SUMO_ARTICLE_HREF}" target="_blank" tabindex="-1"`,
        isCommon: validationError && AuthErrors.is(validationError, 'PASSWORD_TOO_COMMON'),
        isSameAsEmail: validationError && AuthErrors.is(validationError, 'PASSWORD_SAME_AS_EMAIL'),
        isTooShort: validationError && (AuthErrors.is(validationError, 'PASSWORD_REQUIRED') || AuthErrors.is(validationError, 'PASSWORD_TOO_SHORT'))
      });
    }
  }, {
    key: "hideOrShow",
    value: function hideOrShow() {
      if (!this.model.validationError && !this.model.get('inputFocused')) {
        return this.hide();
      } // OneVisibleOfTypeMixin uses 'show' to destroy any other
      // tooltip-like views.


      return this.show();
    }
  }, {
    key: "afterRender",
    value: function afterRender() {
      // We want to conditionally hide after rendering because
      // users can type an invalid password, and then type a valid
      // password and quickly change focus to beat the debounce
      // on the password change event. This allows the model to
      // update but hides the balloon in that scenario. Ref #3750
      this.hideOrShow();
    }
  }, {
    key: "update",
    value: function update() {
      this.clearTimeout(this._hideBalloonElTimeout);
      return this.render();
    }
  }, {
    key: "show",
    value: function show() {
      this.$(PASSWORD_STRENGTH_BALLOON_SELECTOR).removeClass('hidden opacity-0').addClass('opacity-100');
    }
  }, {
    key: "hide",
    value: function hide() {
      const $balloonEl = this.$(PASSWORD_STRENGTH_BALLOON_SELECTOR);
      $balloonEl.addClass('opacity-0').removeClass('opacity-100');
      this._hideBalloonElTimeout = this.setTimeout(() => {
        // In addition to the opacity, the element must be hidden
        // or else it overlays the subsequent input elements making
        // them impossible to click or tap into.
        // `transitionend` is not fired for an unknown reason.
        $balloonEl.addClass('hidden');
      }, DELAY_BEFORE_HIDE_BALLOON_EL_MS);
    }
  }]);

  return PasswordStrengthBalloonView;
}(BaseView);

Cocktail.mixin(PasswordStrengthBalloonView, ExternalLinksMixin, OneVisibleOfTypeMixin({
  hideMethod: 'hide',
  showMethod: 'show',
  viewType: 'tooltip'
}));
export default PasswordStrengthBalloonView;